import { AutocompleteOption } from '@talentmesh/core';

export function isEmptyEducationLevel(option: AutocompleteOption | string): boolean {
    return (
        (typeof option === 'string' && option.trim() === '') ||
        (typeof option === 'object' && option.id === 'UserDefined' && option.label.trim() === '')
    );
}

export function isEmptyAutocompleteOption(option: AutocompleteOption | string): boolean {
    return (
        (typeof option === 'string' && option.trim() === '') ||
        (typeof option === 'object' && option.label.trim() === '')
    );
}

export function isValidDate(date: Date | null, allowNull: boolean = false): boolean {
    if (date === null) {
        return allowNull;
    }

    return date >= new Date('1900-01-01') && date <= new Date();
}
